import { Pipe, PipeTransform } from "@angular/core"; import { Location } from "@angular/common";
import { EmployeEntite } from '../entites/employe';
import { CategorieEntretienEntite } from '../entites/mecanique/categorie-entretien';

@Pipe({
  name: 'colorFromString'
})
export class ColorFromStringPipe implements PipeTransform {

  transform(value: string): string {
    if (value == null || value === undefined || value === '') {
      return '#e0e0e0'; // Default pale gray color for empty strings
    }
    
    // Generate a hash code from the string
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
      hash = value.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Convert to a pale color (high lightness)
    const h = Math.abs(hash) % 360; // Hue: 0-359
    const s = 60; // Saturation: 60% for pale colors
    const l = 85; // Lightness: 85% for pale colors
    
    return `hsl(${h}, ${s}%, ${l}%)`;
  }

}
